export default {
  getSearchResult: (state) => {
    return state.searchResult
  },
  getCashSearchResult: (state) => {
    return state.cashSearchResult
  },
  getQuotaDescription: (state) => {
    return state.quotaDescription
  },
  getDatesISO: (state) => {
    return state.datesISO
  },
  getShowQuotes: (state) => {
    return state.showQuotes
  },
  getFirstPageLoadFlag: (state) => {
    return state.firstPageLoadFlag
  }
}